import crypto from "crypto-browserify";

/**
 * Gets a "random" wave image based on the location pathname.
 * Hashes the location uses the hash to determine the index of the wave image.
 * This is to ensure that the same location path always returns the same wave image.
 * @param {Array} waves The possible wave images.
 * @param {Object} location The location object from react-router-dom.
 * @param {Object} params The parameters object from react-router-dom.
 * @returns {string} The wave image.
 */
export const getWaveImage = (waves, location, params) => {
  const hash = crypto.createHash("sha256");
  
  let identifier = location.pathname;
  // Replace the parameters with their keys to ensure the same image is returned for the same location
  Object.entries(params).forEach(([key, value]) => {
    identifier = identifier.replace(`${value}`, key);
  });

  hash.update(identifier);
  
  const hashedParam = hash.digest("hex").slice(-8);
  const decimalHash = parseInt(hashedParam, 16);
  const index = decimalHash % waves.length;
  
  return waves[index];
};
